import { $convertToMarkdownString } from '@lexical/markdown';
import { SAVE_TRANSFORMERS } from '../../transformers';

import {
  createCommand,
  LexicalCommand,
  COMMAND_PRIORITY_NORMAL,
} from 'lexical';
import React, { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export const SAVE_COMMAND: LexicalCommand<(markdown: string) => Promise<void>> =
  createCommand();

export const SavePlugin: React.FC = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      SAVE_COMMAND,
      fn => {
        const markdown = $convertToMarkdownString(SAVE_TRANSFORMERS);
        fn(markdown);
        return true;
      },
      COMMAND_PRIORITY_NORMAL,
    );
  }, [editor]);

  return null;
};
